import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeOne from '../views/HomeOne.vue'

import HomeSeven from '../views/HomeSeven.vue'
import News from '../views/News.vue'
import SingleNews from '../views/SingleNews.vue'
import Contact from '../views/Contact.vue'
import Error from '../views/Error.vue'
import AboutTwo from '../views/AboutTwo.vue'
import Shops from '../views/Shops.vue'
import ShopDetails from '../views/ShopDetailsPage.vue'
import Functionalities from "@/views/Servcies/Functionalities.vue";
import PrivacyPolicy from "@/views/Support/PrivacyPolicy.vue";
import ConditionUse from "@/views/Support/ConditionUse.vue";
import Pharmacies from "@/views/Servcies/Pharmacies.vue";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home-seven',
    component: HomeSeven
  },
  /*{
    path: '/home-two',
    name: 'HomeTwo',
    component: HomeTwo
  },
  {
    path: '/home-three',
    name: 'HomeThree',
    component: HomeThree
  },
  {
    path: '/home-four',
    name: 'HomeFour',
    component: HomeFour
  },
  {
    path: '/home-five',
    name: 'HomeFive',
    component: HomeFive
  },
  {
    path: '/home-six',
    name: 'HomeSix',
    component: HomeSix
  },*/
  {
    path: '/accueil',
    name: 'HomeSeven',
    component: HomeSeven
  },
  /*{
    path: '/home-eight',
    name: 'HomeEight',
    component: HomeEight
  },
  {
    path: '/home-dark',
    name: 'HomeDark',
    component: HomeDark
  },
  {
    path: '/home-rtl',
    name: 'HomeRtl',
    component: HomeRtl
  },
  {
    path: '/service-details',
    name: 'ServiceDetails',
    component: ServiceDetails
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs
  },*/
  {
    path: '/a-propos',
    name: 'AboutTwo',
    component: AboutTwo
  },
  {
    path: '/shops',
    name: 'Shops',
    component: Shops
  },
  {
    path: '/shop-details',
    name: 'ShopDetails',
    component: ShopDetails
  },
  {
    path: '/about-two',
    name: 'AboutTwo',
    component: AboutTwo
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/single-news',
    name: 'SingleNews',
    component: SingleNews,
    props: true
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    path: '/fonctionnalites',
    name: 'Functionalities',
    component: Functionalities
  },
  {
    path: '/pharmacies',
    name: 'Pharmacies',
    component: Pharmacies
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/condition-of-use',
    name: 'ConditionUse',
    component: ConditionUse
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // stop stop cache
  scrollBehavior() {
      document.getElementById('app').scrollIntoView();
  }
})

export default router
